import { Button } from "@components/atoms";
import { formatCurrency } from "@shared/utils";

interface PurchaseBarProps {
  totalTickets: number;
  /** Subtotal de entradas (precio × cantidad). La comisión y el posible descuento
   *  por método de pago se calculan en el checkout, que es donde se eligen. */
  subtotal: number;
  onPay: () => void;
}

/**
 * seleccion-localidades-inline RF-7 — barra fija de pago, SOLO por debajo de `xl`: de ahí en adelante
 * manda el panel tipo factura que va al lado de las localidades (`PurchaseSummary`).
 * Aparece en cuanto hay al menos una entrada elegida y desaparece al volver a cero.
 */
export function PurchaseBar({ totalTickets, subtotal, onPay }: PurchaseBarProps) {
  if (totalTickets <= 0) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/15 bg-primary-110/95 backdrop-blur pb-[env(safe-area-inset-bottom)] min-[1400px]:hidden">
      <div className="mx-auto flex max-w-screen-2xl items-center justify-between gap-4 px-4 py-3 sm:px-8 lg:px-20">
        <div className="flex flex-col">
          <span className="text-white" style={{ fontSize: 13 }}>
            {totalTickets} {totalTickets === 1 ? "entrada" : "entradas"}
          </span>
          <div className="flex items-baseline gap-2">
            <span className="text-white/60" style={{ fontSize: 12 }}>
              Subtotal
            </span>
            <span className="font-bold text-secondary-120" style={{ fontSize: 18 }}>
              {formatCurrency(subtotal)}
            </span>
          </div>
        </div>

        <Button
          className="h-[46px] px-8 bg-secondary-120 text-primary-110 hover:bg-secondary-120 hover:opacity-90"
          onClick={onPay}
        >
          Pagar
        </Button>
      </div>
    </div>
  );
}
